import { VideoRoomPluginMessage } from './pluginData';
import { ErrorResponse, Request } from './requests';

export class VideoRoomPluginError extends Error {
    constructor(msg: string) {
        super(`VideoRoom plugin error: ${msg}`);
    }
}

export class VideoRoomPluginUnexpectedResponse extends VideoRoomPluginError {
    constructor(public data: VideoRoomPluginMessage['plugindata']['data']) {
        super(`unexpected response: ${JSON.stringify(data)}`);
    }
}

export class VideoRoomPluginErrorEventResponse extends VideoRoomPluginError {
    constructor(public data: ErrorResponse, public req: Request) {
        super(`got an error event: ${JSON.stringify(data)} against ${JSON.stringify(req)}`);
    }
}

export class VideoRoomPluginNoRoomError extends VideoRoomPluginErrorEventResponse {
    constructor(data: ErrorResponse, req: Request) {
        super(data, req);
    }
}

export class VideoRoomPluginRoomAlreadyExistsError extends VideoRoomPluginErrorEventResponse {
    constructor(data: ErrorResponse, req: Request) {
        super(data, req);
    }
}

export function checkError<T extends VideoRoomPluginMessage>(msg: T, req: Request) {
    if (!('error' in msg.plugindata.data)) {
        return undefined;
    }

    switch (msg.plugindata.data.error_code) {
        case 426:
            throw new VideoRoomPluginNoRoomError(msg.plugindata.data, req);
        case 427:
            throw new VideoRoomPluginRoomAlreadyExistsError(msg.plugindata.data, req);
        default:
            throw new VideoRoomPluginErrorEventResponse(msg.plugindata.data, req);
    }
}
